exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinnerButton .buttonContent,.spinnerButton .buttonContent .buttonText{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.spinnerButton .buttonContent .buttonText{height:20px;padding:0 10px}.spinnerButton .buttonContent .spinnerWrapper{width:20px;height:20px;overflow:hidden;display:-ms-flexbox;display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/auth/spinnerButton.scss
// module id = 1291
// module chunks = 2